import { defineComponent as y, useSlots as N, computed as s, useAttrs as V, openBlock as B, createElementBlock as w, normalizeClass as n, createElementVNode as i, mergeProps as S, renderSlot as A } from "vue";
import { usePropsValidation as z } from "../../composables/usePropsValidation.js";
import { omit as E } from "../../utils/omit.js";
import { tw as e } from "../../utils/tailwind.js";
import { CHANGE_EVENT as T } from "./RadioBase.constant.js";
const R = ["id", "checked", "disabled", "value"], x = /* @__PURE__ */ y({
  name: "RevRadioBase",
  inheritAttrs: !1,
  __name: "RadioBase",
  props: {
    modelValue: { type: [Boolean, String] },
    disabled: { type: Boolean, default: !1 },
    id: {},
    label: {},
    value: {},
    checkmarkClassNames: { type: [String, Boolean, Array, Object], default: "" },
    checkmarkTickClassNames: { type: [String, Boolean, Array, Object], default: "" }
  },
  emits: ["change", "update:modelValue"],
  setup(o, { emit: m }) {
    const a = o, p = N(), u = m, d = s(() => !!p.default), l = s(() => !d.value), r = s(() => typeof a.modelValue == "string" ? a.modelValue === a.value : a.modelValue);
    function b(t) {
      t.target.value !== a.modelValue && (u(T, t), u("update:modelValue", t.target.value));
    }
    z({
      "If no slot is passed, `props.label` is mandatory": () => l.value && !a.label
    });
    const f = s(() => {
      const t = V();
      return {
        ...E(t, ["class"]),
        ...l.value && a.label && {
          "aria-label": a.label
        }
      };
    }), v = s(() => [
      e`relative`,
      l.value && e`size-20`
    ]), h = s(() => [
      e`peer appearance-none outline-none`,
      d.value && e`sr-only`,
      l.value && e`rounded-full absolute inset-0 size-20`,
      l.value && !a.disabled && e`cursor-pointer`,
      l.value && a.disabled && e`cursor-not-allowed`
    ]), c = e`rounded-full pointer-events-none absolute`, k = s(() => [
      c,
      a.checkmarkClassNames,
      e`box-border size-20 border`,
      l.value && "left-0 top-0 peer-focus-visible:outline-default-hi",
      r.value ? e`bg-action-default-low-pressed` : e`bg-action-default-low`,
      a.disabled && e`bg-action-default-low-disabled border-action-default-hi-disabled`,
      a.disabled && r.value && e`border-transparent`
    ]), C = s(() => [
      c,
      a.checkmarkTickClassNames,
      e`bg-action-default-low size-8 shrink-0`,
      l.value ? e`left-6 top-6` : e`left-0 top-0`,
      a.disabled && e`bg-action-default-low-pressed opacity-50`,
      r.value ? e`block` : e`hidden`
    ]);
    return (t, g) => (B(), w("div", {
      class: n([t.$attrs.class, v.value])
    }, [
      i("input", S({ id: o.id }, f.value, {
        checked: r.value,
        class: h.value,
        disabled: o.disabled,
        type: "radio",
        value: o.value,
        onChange: b
      }), null, 16, R),
      A(t.$slots, "default"),
      i("div", {
        class: n(k.value)
      }, null, 2),
      i("div", {
        class: n(C.value)
      }, null, 2)
    ], 2));
  }
});
export {
  x as default
};
